module.exports = __webpack_public_path__ + "img/burger-ex-3.0c6c8f86.svg";